import React from "react";
import { FormControl, TextField, Autocomplete } from "@mui/material";

import "./organization-selection-styles.scss";
import datastore from "../store/hoa-datastore";
import dashboardServices from "../services/hoa-dashboard-api-service";
import { mappingNotVisibleKeys } from "../utility/data-configurator-helper";

const OrganizationSelection = ({state, setState, updateSelectedDataFieldConfigurator}: any) => {
    
  const handleOrganization = async (org: any) => {
    datastore.selectedOrganization = org;
    setState({...state, selectedOrganization: org})
    const { data } = await dashboardServices.getDataFieldConfiguratorByOrganizationId(datastore.selectedOrganization.id);
    if(data?.hoaConfig && data?.hoaConfig?.fieldData){
        datastore.selectedConfiguration = data.hoaConfig.fieldData;
        mappingNotVisibleKeys(data.hoaConfig.fieldData);
        updateSelectedDataFieldConfigurator(data.hoaConfig.fieldData)
    }
  };

  return (
    <div className="center">
      <FormControl>
        <Autocomplete
          ListboxProps={{ style: { maxHeight: "100px" } }}
          style={{ width: "300px", margin: "2px" }}
          disableClearable
          disablePortal
          value={state.selectedOrganization?.label || ""}
          options={datastore.organizations}
          onChange={(e, v) => handleOrganization(v)}
          renderInput={(params) => (
            <TextField name="organization" {...params} label="Organizations" />
          )}
        />
      </FormControl>
    </div>
  );
};

export default OrganizationSelection;
